import { bool, number } from 'prop-types';
import React from 'react';
import CurrencyNumberFormat from 'react-number-format';

function transformSmallValueToZero(value, decimalScale) {
  const smallestDisplayedNumber = 1 / 10 ** decimalScale;

  return Math.abs(value) < smallestDisplayedNumber ? 0 : value;
}

function CurrencyFormat({ value, text, hasPrefix, ...rest }) {
  const decimalScale = rest.decimalScale || 2;
  return (
    <CurrencyNumberFormat
      value={transformSmallValueToZero(value, decimalScale)}
      thousandSeparator=" "
      decimalSeparator="."
      decimalScale={decimalScale}
      prefix={hasPrefix ? '€ ' : ''}
      displayType={text ? 'text' : 'input'}
      {...rest}
    />
  );
}

CurrencyFormat.propTypes = {
  value: number,
  text: bool,
  hasPrefix: bool,
};

CurrencyFormat.defaultProps = {
  value: undefined,
  text: false,
  hasPrefix: true,
};

export default CurrencyFormat;
